var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0772 12.0103C22.0772 6.48783 17.5952 2.00586 12.0728 2.00586C6.55033 2.00586 2.06836 6.48783 2.06836 12.0103C2.06836 16.8524 5.50987 20.8842 10.0719 21.8146V15.0116H8.071V12.0103H10.0719V9.50916C10.0719 7.57831 11.6426 6.00762 13.5734 6.00762H16.0745V9.00894H14.0736C13.5234 9.00894 13.0732 9.45914 13.0732 10.0094V12.0103H16.0745V15.0116H13.0732V21.9646C18.1254 21.4644 22.0772 17.2026 22.0772 12.0103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.60c020dc65fbadb1ef6a1f0dad27356b.svg";
export { ForwardRef as ReactComponent };